
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/priority-messages/new",
      function () {
        return require("private-next-pages/tools/priority-messages/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/priority-messages/new"])
      });
    }
  